import { Box, Button, DialogActions, Modal, Stack, TextField, Typography } from '@mui/material'
import type React from 'react'
import { useContext, useEffect, useRef, useState } from 'react'
import { salesCompanySchema } from '../schema/organizationSchema'
import { LanguageContext } from '../util/LanguageContext'

type ModalDeviceSalesCompanyEditDialogProps = {
  open: boolean
  title: string
  id: string
  text: string
  onClose: () => void
  onSave: (id: string, value: string) => void
}

export const ModalDeviceSalesCompanyEditDialog: React.FC<
  ModalDeviceSalesCompanyEditDialogProps
> = props => {
  const { open, title, id, text, onClose, onSave } = props
  const [inputValue, setInputValue] = useState(text)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [error, setError] = useState('')
  // 文字列変換用
  const translation = useContext(LanguageContext)

  const validate = async (value: string) => {
    try {
      await salesCompanySchema.validate(value)
      setError('')
      setIsButtonDisabled(false)
    } catch (err: any) {
      setError(err.message)
      setIsButtonDisabled(true)
    }
  }

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
    validate(event.target.value)
  }

  const handleSave = () => {
    onSave(id, inputValue)
    onClose()
  }

  useEffect(() => {
    setIsButtonDisabled(inputValue !== text ? false : true)
  }, [inputValue, text])

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '31%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: '443px',
          width: '740px',
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 16,
        }}
      >
        <Stack justifyContent="center" alignItems="center">
          <Typography
            sx={{
              mt: '50px',
              font: 'normal normal bold 32px/48px BIZ UDGothic',
              textAlign: 'center',
            }}
          >
            {translation['button_edit']}
          </Typography>

          <Typography
            sx={{
              mt: '50px',
              color: '#282828',
              font: 'normal normal normal 21px/32px Noto Sans JP',
              position: 'absolute',
              top: '80px',
              left: '130px',
              textAlign: 'left',
            }}
          >
            {title}
          </Typography>
          <TextField
            label=""
            value={inputValue}
            inputRef={inputRef}
            onChange={handleInputChange}
            error={!!error}
            helperText={error ? translation[error] : ' '}
            InputProps={{
              sx: {
                mt: '72px',
                font: 'normal normal normal 21px/34px BIZ UDPGothic',
                borderRadius: '10px',

                background: '#F4F4F4',
                height: '72px',
                width: '480px',
              },
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                // "& fieldset": {
                //   borderColor: "white",
                // },
                // "&:hover fieldset": {
                //   borderColor: "white",
                // },
                '&.Mui-focused fieldset': {
                  borderColor: error ? 'red' : '#282828',
                },
              },
            }}
            // focused
          />
          <DialogActions sx={{ mt: '60px' }}>
            <Button
              onClick={onClose}
              sx={{
                height: '49px',
                width: '181px',
                font: 'normal normal bold 21px/29px Noto Sans JP',
                color: '#282828',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                border: '2px solid #282828',
                borderRadius: '10px',
                mr: '40px',
                '&:hover': {
                  background: '#FFFFFF',
                  opacity: 0.8,
                },
              }}
            >
              {translation['button_cancel']}
            </Button>
            <Button
              type="submit"
              disabled={isButtonDisabled}
              onClick={handleSave}
              sx={{
                height: '49px',
                width: '181px',
                font: 'normal normal bold 21px/29px Noto Sans JP',
                color: isButtonDisabled ? '#CACACA' : '#FFFFFF',
                background: isButtonDisabled ? '#F4F4F4 0% 0% no-repeat padding-box' : '#282828',
                '&:hover': {
                  backgroundColor: '#282828',
                  opacity: 0.8,
                },
                borderRadius: '10px',
              }}
            >
              {translation['button_decide']}
            </Button>
          </DialogActions>
        </Stack>
      </Box>
    </Modal>
  )
}
